import {InsuranceSellContextEnum} from "../../insurance-sell-context.enum";

export function getNeatWebsitePage(sellContext: InsuranceSellContextEnum): string {
    switch (sellContext) {
        case InsuranceSellContextEnum.ExtrasPage:
            return "extras";
        default:
            return "payment";
    }
}